import {ChildAccount} from '../interfaces/childAccountResponse';
import { AdminAccountService, DavisAlertService, ListingModalService, BookService } from '@DavisDigital/davisdigitalfrontend.module';

class AdminBulkPermissionController {

	//Properties for Bulk account permission management
	public showSummary:boolean = false;
	public assignedLicenses: { [key: string]: Array<any> } = {};
	public unassignedLicenses: { [key: string]: Array<any> } = {};
	public accountidList:string;
	public allAccountsSelected:boolean;
	public accountFilters:any;
	public selectedAccounts;
	public pageRole:string;
	public grantLicenses = [];
	public removeLicenses = [];
	public activateAccounts:boolean = false;
	public removeAllLicenses:boolean = false;
	public accountPermissionSummary = [];
	public callbackFunction:Function;
	public grantPortfolioAccess = false;
	public grantImageAccess = false;
	public studentsAssignedToBook : { [key: string]: Array<any> } = {};


	//Properties for Bulk account permission management -- END	
	
	public loading = false;
	
	// @ngInject
	constructor(
		 private adminAccountService:AdminAccountService,
		 private listingModalService : ListingModalService,
		 private bookService : BookService,
		 private $sce : any
	){}
	
	public $onInit = () => {
		this.loadLicenseInformation( this.accountidList, this.allAccountsSelected, this.accountFilters );
	}
	
	/**
	 * Method to load license information
	 * */
	public loadLicenseInformation = ( accountIDList:string, allAccountsSelected: boolean, accountFilters: any ) => {
		this.loading = true;
		this.adminAccountService.getLicenseData(accountIDList, this.pageRole == "student", allAccountsSelected, accountFilters).then(res => {
			this.assignedLicenses = res.data.assignedLicenses;
			this.unassignedLicenses = res.data.unassignedLicenses; // book licences
			this.selectedAccounts = res.data.accounts;
		}).finally(() => {
			this.loading = false;
		});
	}
	
	/**
	 * Method to handle grant license checkbox click
	*/
	public toggleGrantLicenses(baseObjectID,title): void {
		if(this.grantLicenses.indexOf(baseObjectID) > -1){
			//on un-check making it false
			if(title=="Full Image Access") {
				this.grantImageAccess = false;
			}
			if(title=="Student Full Portfolio Access") {
				this.grantPortfolioAccess = false;
			}
			this.grantLicenses.splice(this.grantLicenses.indexOf(baseObjectID), 1);
		}else{
			//on check making it false
			if(title=="Full Image Access") {
				this.grantImageAccess = true;
			}
			if(title=="Student Full Portfolio Access") {
				this.grantPortfolioAccess = true;
			}
			this.grantLicenses.push(baseObjectID);
		}
	}
	
	/**
	 * Method to handle remove license checkbox click
	*/
	public toggleRemoveLicenses(baseObjectID): void {
		if(this.removeLicenses.indexOf(baseObjectID) > -1){
			this.removeLicenses.splice(this.removeLicenses.indexOf(baseObjectID), 1);
		}else{
			this.removeLicenses.push(baseObjectID);
		}
	}
	
	/**
	 * Method to show list of user summary against assigned licenses
	 */
	public onUsersListModal(baseObjectID):void{
		this.loading = true;
		this.adminAccountService.getAssignedAccountIDs(this.accountidList,this.pageRole == "student",baseObjectID=baseObjectID).then(res => {
		this.studentsAssignedToBook = res.data.assignedLicenses;
		let typeKey = null;
		let types = Object.keys(this.studentsAssignedToBook);
		
		let itemIndex;
		for (let t of types) {
			itemIndex = this.studentsAssignedToBook[t].findIndex(item => item.baseObjectID === baseObjectID);
			if (itemIndex >= 0) {
				typeKey = t;
				break;
			}
		}
		if( typeKey && itemIndex > -1) {
			//Prepare user array to show in Modal Box
			let assignedAccounts = [];
			for(var i=0; i < res.data.assignedLicenses.book.length; i++) {
				let accountID = this.studentsAssignedToBook[typeKey][i].assignedAccountIDs;
				let accountIndex = this.selectedAccounts.findIndex(item => item.accountID === accountID );
				if( accountIndex > -1 ) {
					assignedAccounts.push(this.selectedAccounts[accountIndex]);
				}
			}
			this.listingModalService.launchUserSummaryModal( assignedAccounts, this.studentsAssignedToBook[typeKey][itemIndex].title);
		}
		}).finally(() => {
			this.loading = false;
		});
	}
	
	/**
	 * Method to prepar array to show on Permission Summary
	*/
	public showPermissionSummary = () => {
		//Prepare Summary
		this.showSummary = true;
		this.accountPermissionSummary = [];
		let unassignedLicensesCopy = angular.copy(this.unassignedLicenses);
		let assignedLicensesCopy = angular.copy(this.assignedLicenses);
		let licenseCounts = { unassigned : {}, assigned : {} };
		
		this.selectedAccounts.forEach(account => {
			let actions = [];
			
			if( this.removeAllLicenses ) {
				actions.push("All licenses will be removed.");
			}
			
			if( this.activateAccounts ) {
				actions.push("Account will be activated.");
			}
			
			if( this.grantPortfolioAccess ) {
				actions.push("Account will have access to Portfolios");
			}
			
			if( this.grantImageAccess ) {
				actions.push("Account will have access to Images");
			}
			
			//Assign license related messages.
			for (let license in this.unassignedLicenses['book']) {
				let baseObjectId = this.unassignedLicenses['book'][license]['baseObjectID'];
				if( this.grantLicenses.indexOf(baseObjectId) > -1) {
					if ( licenseCounts.unassigned[baseObjectId] === undefined ) {
						licenseCounts.unassigned[baseObjectId] = this.unassignedLicenses['book'][license]['unassignedCount'];
					}
					let sample = this.isSampleBook( this.unassignedLicenses['book'][license]['bookCode'] ) ? ' Sample' : '';
					if( licenseCounts.unassigned[baseObjectId] > 0 ) {
						actions.push(`Book ${this.unassignedLicenses['book'][license]['title']} ${sample} ${this.unassignedLicenses['book'][license]['typeName']} will be assigned.`);	
						licenseCounts.unassigned[baseObjectId]--;
					} else {
						actions.push(this.$sce.trustAsHtml(`<strong style="color:red;">Book ${this.unassignedLicenses['book'][license]['title']} ${sample} ${this.unassignedLicenses['book'][license]['typeName']} has no more licenses.</strong>`));	
					}
				}
			}
			
			for (let license in this.assignedLicenses['book']) {
				let baseObjectId = this.assignedLicenses['book'][license]['baseObjectID'];
				if( this.removeLicenses.indexOf(baseObjectId) > -1) {
					if ( licenseCounts.assigned[baseObjectId] === undefined ) {
						licenseCounts.assigned[baseObjectId] = this.assignedLicenses['book'][license]['assignedCount'];
					}
					let sample = this.isSampleBook( this.assignedLicenses['book'][license]['bookCode'] ) ? ' Sample' : '';
					//license has assigned count and accountID exists in with assignedLicense records
					if( licenseCounts.assigned[baseObjectId] > 0 && this.assignedLicenses['book'][license]['assignedAccountIDs'].split(",").indexOf(account['accountID']) > -1 ) {
						actions.push(`Book ${this.assignedLicenses['book'][license]['title']} ${sample} ${this.assignedLicenses['book'][license]['typeName']} will be removed.`);	
						licenseCounts.assigned[baseObjectId]--;
					}
				}
			}
			
			
			this.accountPermissionSummary.push(
				{
					"account": account,
					"actions" : actions
				}
			);
		});
	}
	
	public isSampleBook = (bookCode) => this.bookService.isSampleBook(bookCode);
	
	/**
	 * Method to Update License permissions
	*/
	public updateAccountLicenses = () => {
		this.loading = true;
		this.adminAccountService.updateLicensePermissions(this.accountidList, this.grantLicenses.join(), this.removeLicenses.join(), this.removeAllLicenses, this.activateAccounts, this.grantPortfolioAccess, this.grantImageAccess, this.allAccountsSelected, this.accountFilters).then(res => {
			if( res.data.successfulActions.length ) {
				this.resetAccountPermission();
				// TODO: show toast saying email will be sent when finished in case of res.data.batchQueued === true
				//callback
				this.callbackFunction();
			}
		}).finally(() => {
			this.loading = false;
		});
	}
	
	/**
	 * Reset Permission properties
	*/
	public resetAccountPermission = () => {
		this.showSummary = false;
		this.assignedLicenses = this.baseLicenceObject();
		this.unassignedLicenses = this.baseLicenceObject();
		this.selectedAccounts = [];
		this.accountidList = "";
		this.grantLicenses = [];
		this.removeLicenses = [];
		this.removeAllLicenses = false;
		this.activateAccounts = false;
	}
	
	private baseLicenceObject = (): { [key: string]: [] } => { return { 'book': [], 'permissionGroup': [] } };
}

class AdminBulkPermission {
	public restrict: string = 'E';
	public templateUrl: string;
	public scope: boolean = true;
	
	public bindToController: any = {
		selectedAccounts: '=',
		accountidList: '=',
		callbackFunction: '=',
		allAccountsSelected: '=',
		accountFilters: '=',
		pageRole: '=?',
	};

	public controller = AdminBulkPermissionController;
	public controllerAs = 'adminBulkPermission';

	public static Factory() {
		var directive:any = ( davisFrontendBasePath ) => new this( davisFrontendBasePath );
		directive.$inject = ['davisFrontendBasePath'];
		return directive;
	}

	constructor(
		private davisFrontendBasePath
	) {
		this.templateUrl = davisFrontendBasePath + '/davisdigital/directives/admin-bulk-permission.html';
	}
}

export { AdminBulkPermission };
